<template>
  <v-container>
    <v-layout>
      <v-flex lg12>
        <jti-expansion-panel panelName="DLTB Employee Details">
          <v-form ref="form" lazy-validation>
            <v-container grid-list-lg>
              <v-layout wrap>
                <v-flex lg4>
                  <img height="200" width="200" :src="data.idPicture" />
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="data.firstName"
                    label="First name"
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="data.middleName"
                    label="Middle Name"
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="data.lastName"
                    label="Last Name"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="data.empNo"
                    label="Employee No."
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="data.empStatus"
                    label="Employee Status"
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="data.designation"
                    label="Designation"
                    readonly
                  ></v-text-field
                  >&nbsp;&nbsp;&nbsp;
                  <img height="75" width="100%" :src="data.idSignature" />
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex>
                  <v-text-field
                    v-model="data.idPicture"
                    label="ID Picture"
                    readonly
                  ></v-text-field>

                  <v-text-field
                    v-model="data.idSignature"
                    label="ID Signation"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </jti-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  methods: {
    clear() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
.imageClass {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
}
</style>
